import { getSessionGlobalUserId } from "@/pages/datalab/utils/common"
import { getOpinionFilterCond } from "@/pages/intelligence/services/opinion"
import { useEffect, useState } from "react"

export default (props: any) => {
  const [filterResult, setFilterResult] = useState({})
  // console.log("overview", props)

  const fetchData = async () => {
    try {
      const filterResultTmpe = await getOpinionFilterCond({
        user_id: getSessionGlobalUserId(),
        unified_edition_id: props.gameId,
        request_type: ['topic', 'channel',
          'monitor_by_account', 'monitor_by_keyword',
          'monitor_by_account_new', 'monitor_by_keyword_new',
          'region', 'country', 'language', 'region_country'],
        entity_type: props.entityType,
        id_type: 'unified_id',
      })
      
      setFilterResult(filterResultTmpe)
    } catch(e) {
      console.log(e)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  return {
    filterResult
  }
}